import { apiDelete, apiGet } from "./apiClient";

async function getCollection(path, errorMessage) {
  const res = await apiGet(path);
  if (!res.ok) return { ok: false, error: res.error ?? errorMessage, items: [] };
  return { ok: true, items: Array.isArray(res.data) ? res.data : [] };
}

export function fetchCountriesList() {
  return getCollection("/api/Countries", "Failed to load countries");
}

export function deleteCountry(id) {
  return apiDelete(`/api/Countries/${id}`);
}

export function fetchStatesList() {
  return getCollection("/api/States", "Failed to load states");
}

export function deleteState(id) {
  return apiDelete(`/api/States/${id}`);
}

export function fetchCitiesList() {
  return getCollection("/api/Cities", "Failed to load cities");
}

export function deleteCity(id) {
  return apiDelete(`/api/Cities/${id}`);
}

export function fetchCurrenciesList() {
  return getCollection("/api/Currencies", "Failed to load currencies");
}

export function deleteCurrency(id) {
  return apiDelete(`/api/Currencies/${id}`);
}
